<template>
  <div class=" hight-time">
    <div class="zz-page highlight-time-page">
      <!-- 顶部标题 -->
      <otherHeaderTop ref="headerTop" headerTitle="高光时刻" :showBack="true" @back="back" :showBalanceTwo="false"></otherHeaderTop>
      <div class="visitor-info">
        <img src="../../../assets/image3/high_time/headBack.png" alt="" class="visitor-bg" mode="aspectFit" />
        <div class="user-info">
          <div class="avatar">
            <img :src="$getFullPath(user.avatar)
              ? $getFullPath(user.avatar)
              : '../../../assets/images/default-header.png'
              " alt="" class="header-main" mode="aspectFit" />
          </div>
          <div class="nickname-box">
            <div class="nickname text-ellipsis">
              {{ user.nickName }}
            </div>
            <!-- <text class="no-visitor text-ellipsis">0人近期访问 </text> -->
          </div>
        </div>
        <div class="info-col">
          <div class="avatar-list">
            <div style="opacity: 0">占位...</div>
          </div>
        </div>
      </div>
      <!-- <img src="../../../assets/images/tab-bg.png" alt="" class="tab-bg" mode="aspectFit" /> -->
      <div class="tabs">
        <div @click="changeTab(0)" :class="[tab == 0 ? 'active-tab' : 'inactive-tab']" class="tab">
          近期获得
        </div>
        <div @click="changeTab(1)" :class="[tab == 1 ? 'active-tab' : 'inactive-tab']" class="tab">
          盲盒TOP
        </div>
      </div>
      <div class="box-main">
        <!-- <div class="box-header-bg"></div> -->
        <div class="box-list drop-info-all" v-if="tab == 0">
          <div role="feed" class="van-list drop-list" @scroll="scrollEventFn">
            <div class="drop-item color-blue" v-for="(item, index) in lists" :key="index">
              <div class="open-time">{{ item.create_time }}</div>
              <div class="item-c0">
                <div class="head-box">
                  <img :src="$getFullPath(user.avatar)" class="head-img" />
                  <!-- <div class="head-mask"></div> -->
                </div>
                <div class="nick text-ellipsis">{{ user.nickName }}</div>
              </div>
              <div style="width: 0px;
height: 31px;
border-radius: 0px 0px 0px 0px;
border: 1px solid rgba(81,235,255,0.42);position: absolute;top: 20px;left: 50%;"></div>
              <div class="item-c1" style="opacity: 0">
                <div class="c1-name text-ellipsis">{{ item.shortName }}</div>
                <div class="c1-price">
                  <img src="../../../assets/images/balance2.png" class="coin" />
                  <span>2</span>
                </div>
                <div class="c1-time"></div>
              </div>
              <div class="item-c2">
                <div class="c2-name text-ellipsis">
                  {{ item.shortName }}
                </div>
                <div class="c2-price">
                  <img src="@/assets/home/jinbi.png" class="coin" />
                  <span>{{ item.ornamentsPrice }}</span>
                </div>
              </div>
              <div class="item-c3 flex-center">
                <img :src="$getFullPath(item.imageUrl)" class="img" />
              </div>
            </div>
            <div v-if="lists.length == 0">
              <div class="no-data">
                <div class="empty-box-new"></div>
                <div class="tip-text">暂无数据</div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-list" v-if="tab == 1">
          <div class="box-item box-classic">
            <div class="box-left">
              <span class="box-name">经典盲盒</span>
              <!-- <img src="../../../assets/images/box-classic.png" alt="" class="box-type" mode="widthFix" /> -->
              <img v-if="high.length != 0 && high[0].imageUrl != null" class="box-gun" :src="high[0].imageUrl"
                mode="aspectFit" />
            </div>
            <div class="box-right">
              <template v-if="high.length != 0 && high[0].createTime != null">
                <div class="box-time">
                  {{ high[0].createTime }}
                </div>
                <div class="box-msg">
                  <div class="box-msg-value">
                    <div style="display: flex;align-items: center;">
                      <div class="dot-main dot-main-classic"></div>
                      <div>价值</div>
                    </div>

                    <div class="value-name">
                      <img src="../../../assets/images/balance2.png" />
                      <div>{{ high[0].ornamentsPrice }}</div>
                    </div>
                  </div>

                  <div class="box-msg-name">
                    <div style="display: flex;align-items: center;">
                      <div class="dot-main dot-main-classic"></div>
                      <div>名称</div>
                    </div>

                    <div class="value-name">
                      <div class="name">{{ high[0].ornamentName }}</div>
                    </div>
                  </div>
                  <div class="font-price" style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    ">
                    <!-- <div class="name-main">开盒价</div> -->
                    <!-- <div
                      style="
                        width: 230px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        text-align: center;
                      "
                    >
                      {{ high[0].huo_price }}
                    </div> -->
                  </div>
                </div>
              </template>
              <div class="box-msg empty" v-else>
                <div>暂无数据</div>
              </div>
            </div>
          </div>
          <div class="box-item box-fight">
            <div class="box-left">
              <span class="box-name">盲盒对战</span>
              <!-- <img src="../../../assets/images/box-fight.png" alt="" class="box-type" mode="widthFix" /> -->
              <img v-if="high.length != 0 && high[1].imageUrl != null" class="box-gun" :src="high[1].imageUrl"
                mode="aspectFit" />
            </div>
            <div class="box-right">
              <template v-if="high.length != 0 && high[1].createTime != null">
                <div class="box-time">
                  {{ high[1].createTime }}
                </div>

                <div class="box-msg">
                  <div class="box-msg-value">
                    <div style="display: flex;align-items: center;">
                      <div class="dot-main dot-main-classic"></div>
                      <div>价值</div>
                    </div>

                    <div class="value-name">
                      <img src="../../../assets/images/balance2.png" />
                      <div>{{ high[1].ornamentsPrice }}</div>
                    </div>
                  </div>

                  <div class="box-msg-name">
                    <div style="display: flex;align-items: center;">
                      <div class="dot-main dot-main-classic"></div>
                      <div>名称</div>
                    </div>

                    <div class="value-name">
                      <div class="name">{{ high[1].ornamentName }}</div>
                    </div>
                  </div>

                  <div class="font-price" style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    ">
                    <!-- <div class="name-main">开盒价</div> -->
                    <!-- <div
                      style="
                        width: 230px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        text-align: center;
                      "
                    >
                      {{ high[1].huo_price }}
                    </div> -->
                  </div>
                </div>
              </template>
              <div class="box-msg empty" v-else>
                <div>暂无数据</div>
              </div>
            </div>
          </div>
          <div class="box-item box-lucky">
            <div class="box-left">
              <span class="box-name">幸运饰品</span>
              <!-- <img src="../../../assets/images/box-lucky.png" alt="" class="box-type" mode="widthFix" /> -->
              <img v-if="high.length != 0 && high[2] != null" class="box-gun" :src="high[2].imageUrl"
                mode="aspectFit" />
            </div>
            <div class="box-right">
              <template v-if="high.length != 0 && high[2] != null">
                <div class="box-time">
                  {{ high[2].createTime }}
                </div>
                <div class="box-msg">
                  <div class="box-msg-value">
                    <div style="display: flex;align-items: center;">
                      <div class="dot-main dot-main-classic"></div>
                      <div>价值</div>
                    </div>

                    <div class="value-name">
                      <img src="../../../assets/images/balance2.png" />
                      <div>{{ high[2].ornamentsPrice }}</div>
                    </div>
                  </div>

                  <div class="box-msg-name">
                    <div style="display: flex;align-items: center;">
                      <div class="dot-main dot-main-classic"></div>
                      <div>名称</div>
                    </div>

                    <div class="value-name">
                      <div class="name">{{ high[2].ornamentName }}</div>
                    </div>
                  </div>

                  <div class="font-price" style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    ">
                    <!-- <div class="name-main">开盒价</div> -->
                    <!-- <div
                      style="
                        width: 230px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        text-align: center;
                      "
                    >
                      {{ high[2].huo_price }}
                    </div> -->
                  </div>
                </div>
              </template>
              <div class="box-msg empty" v-else>
                <div>暂无数据</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!---->
      <div class="box-footer"></div>
    </div>
    <!-- <u-notify ref="uNotify" message=""></u-notify> -->
  </div>
</template>

<script>
import otherHeaderTop from "@/components/otherHeaderTop.vue";
import { getPackSack, getBindBoxTop } from "@/api/index";
export default {
  components: {
    otherHeaderTop,
  },
  data() {
    return {
      user: {},
      tab: 0,
      page: 1,
      limit: 20,
      isOver: "加载中",
      lists: [],
      high: {
        classic: null,
        lucky: null,
        battle: null,
      },
      page: {
        page: 1,
        size: 20,
        orderByFie: 1,
        orderByType: 2,
        name: "",
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.init();
  },
  //   onLoad() {
  //     // this.user = uni.getStorageSync("user");
  //     this.getLists();
  //     this.getHighTime();
  //   },

  methods: {
    back() {
      this.$router.go(-1);
    },
    changeTab(tab) {
      console.log(tab, "cede1");
      this.tab = tab;
    },
    getHighTime() {
      getBindBoxTop().then((res) => {
        console.log(res);
        this.high = res.data.data;
      });
    },
    getLists() {
      getPackSack(this.page).then((res) => {
        console.log("getPackSack", res);
        let lists = [];
        lists = res.data.data;
        this.lists.push(...lists);
        if (lists.length < this.page.size) {
          this.isOver = "暂无更多";
        }
      });
    },
    // 触底加载
    scrollEventFn(event) {
      // this.event = e;
      // // const container = event.target;
      const container = event.target;
      // console.log("触底了",container.scrollTop + container.clientHeight,container.scrollHeight);
      if (
        (container.scrollTop + container.clientHeight) + 1 >=
        container.scrollHeight
      ) {
        if (this.isOver == "加载中") {
          this.page.page++;
          setTimeout(() => {
            this.getLists();
          }, 5);
        } else {
          this.$message({
            duration: 1000,
            message: "暂无更多数据",
            type: "warning",
            customClass: "log_warning",
          });
        }
      }
    },
    init() {
      this.user = this.$store.state.USER_INFO;
      this.getLists();
      this.getHighTime();
    },
  },
};
</script>

<style scoped lang="scss">
.hight-time {
  --head-height: 14 * 4.2px;
}

.highlight-time-page {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow-y: visible;
}

.highlight-time-page .highlight-time-title-img {
  width: 23.47 * 4.2px;
  height: 5.87 * 4.2px;
  -webkit-transform: scale(0.9);
  -ms-transform: scale(0.9);
  transform: scale(0.9);
}

.highlight-time-page .new-s-custom-tabs-wrap {
  padding-top: 2 * 4.2px;
}

.highlight-time-page .visitor-info {
  margin: -webkit-calc(7.33 * 4.2px) 6.67 * 4.2px 0 10.67 * 4.2px;
  margin: calc(7.33 * 4.2px) 6.67 * 4.2px 0 10.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 13.33 * 4.2px;
}

.highlight-time-page .visitor-info .visitor-bg {
  width: 92.53 * 4.2px;
  height: 20.13 * 4.2px;
  position: absolute;
  top: -webkit-calc(var(--head-height) + 3.33 * 4.2px);
  top: calc(var(--head-height) + 3.33 * 4.2px);
  left: 3.67 * 4.2px;
  opacity: 0.6;
}

.highlight-time-page .visitor-info .user-info {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
}

.highlight-time-page .visitor-info .user-info .avatar {
  width: 11.47 * 4.2px;
  height: 11.47 * 4.2px;
  position: relative;
}

.highlight-time-page .visitor-info .user-info .avatar .header-bg {
  width: 25.33 * 4.2px;
  height: 23.6 * 4.2px;
  position: absolute;
  top: -6 * 4.2px;
  left: -7.33 * 4.2px;
}

.highlight-time-page .visitor-info .user-info .avatar .header-main {
  width: 11.9 * 4.2px;
  height: 11.9 * 4.2px;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  overflow: hidden;
}

.highlight-time-page .visitor-info .user-info .nickname-box {
  height: 11.9 * 4.2px;
  line-height: 11.9 * 4.2px;
  margin-left: 2.38 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 11.9vw;
    line-height: 11.9vw;
    margin-left: 2.38vw;
  }
}

.highlight-time-page .visitor-info .user-info .nickname {
  width: 37.33 * 4.2px;
  font-size: 14px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  font-weight: 700;
  color: #d4d4ff;
  white-space: nowrap;
  position: absolute;
  // top: -2.7 * 4.2px;
  // left: 17.33 * 4.2px;
  text-align: left;
}

.highlight-time-page .visitor-info .user-info .no-visitor {
  width: 22 * 4.2px;
  margin-top: 4.67 * 4.2px;
  margin-left: 12.67 * 4.2px;
  font-size: 2.67 * 4.2px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  color: #ffffff;
}

.highlight-time-page .visitor-info .info-col {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
  -webkit-align-items: end;
  -ms-flex-align: end;
  align-items: end;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
}

.highlight-time-page .visitor-info .info-col text,
.highlight-time-page .visitor-info .info-col div {
  position: relative;
  z-index: 1;
}

.highlight-time-page .visitor-info .info-col text {
  font-size: 2.67 * 4.2px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ffffff;
}

.highlight-time-page .visitor-info .info-col .avatar-list {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 7.33 * 4.2px;
  width: 33.07 * 4.2px;
}

.highlight-time-page .visitor-info .info-col .avatar-list .avatar-img {
  margin-left: 1.07 * 4.2px;
  width: 7.2 * 4.2px;
  height: 7.2 * 4.2px;
}

.highlight-time-page .visitor-info .info-col .avatar-list .avatar-img img {
  -webkit-border-radius: 50%;
  border-radius: 50%;
  width: 7.2 * 4.2px;
  height: 7.2 * 4.2px;
}

.highlight-time-page .tab-bg {
  width: 100 * 4.2px;
  height: 12.8 * 4.2px;
  position: absolute;
  top: -webkit-calc(var(--head-height) + 21.33 * 4.2px);
  top: calc(var(--head-height) + 21.33 * 4.2px);
  z-index: 1;
}

.highlight-time-page .tabs {
  position: relative;
  z-index: 2;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  // -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  // justify-content: space-between;
  margin: 5.67 * 4.2px 3.8 * 4.2px 3.67 * 4.2px;
}

.highlight-time-page .tabs .tab {
  width: 20.33 * 4.2px;
  text-align: center;
  font-size: 3.33 * 4.2px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  // font-weight: 700;
  color: #ffffff;
  line-height: 8.67 * 4.2px;
  // padding-top: 0.67 * 4.2px;
}

.highlight-time-page .tabs .inactive-tab {
  background: url("../../../assets/image3/share/notSelectedBack.png") no-repeat 0 0;
  background-size: 22.33 * 4.2px 8.67 * 4.2px;
}

.highlight-time-page .tabs .active-tab {
  background: url("../../../assets/image3/share/selectBack.png") no-repeat 0 0;
  background-size: 22.33 * 4.2px 8.67 * 4.2px;
}

.highlight-time-page .bg-content {
  -webkit-transform: translate(0, -2.8 * 4.2px);
  -ms-transform: translate(0, -2.8 * 4.2px);
  transform: translate(0, -2.8 * 4.2px);
  height: 66.67 * 4.2px;
  background: url(data:image/png;base64,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*4.2pxIk7cODEHThwCq97DE7htSacwmu90ym8TkrbKbwWDIXXyWc7hdfCofBaE07htfBdofCawmsKrym8pvCawmsKrym8pvBa+KsBhddayim81oRTeC1cU3jdI7ZTeC38EJXC63gop/C6e8opvAZO4bWEzpc3gCctnLgDJ+74Dpy44ztw4o7*4.2pxIk7vgMn7vgOnLgDB07cgQMn7sCBE3fgwIk7cODEHThxx3fgxB3fgRN3fAdO3PEdOHHHd+DEHThw4g4cOIXXPQan8FoTTuG13ukUXiel7RReC4bC6+SzncJr4VB4rQmn8Fr4rlB4TeE1hdcUXlN4TeE1hdcUXlN4LfzVgMJrLeUUXmvCKbwWrim87hHbKbwWfohK4XU8lFN43T3lFF4Dp/BaQufLG8CTFk7cgRN3fAdO3PEdOHHHd+DEHd+BE3d8B07cgQMn7sCBE3fgwIk7cODEHThw4g6cuOM7cOKO78CJO74DJ+74Dpy44ztw4g4cOHEHDpzC6x6DU3itCafwWu90Cq+T0nYKrwVD4XXy2Z5khddNBz2dpvW5Z59K8Qinrvnmm8ZI1tNn3v9AnXg/5tWZ0yWnt748c3qdNjxl5eYv2zz6cIXyn0/95EB56/efNzuAJ7DtCnjdkS9+/aoufvBTpyVrz5EPu5x+sMkI+js9BtyVNcs2hUS3U9DImztpfmWqYB9dLxpVW1RlDBQ8ZNw5r2ycJzo9zTAraxa8lCeqIwwaDVH4zoDodHtCv/raE98In3AKuEr517/9MEMIVyo3c2qWN+rDE9d2BXygUXVie/2iBlsXrlS+YH5lQAgP7Pxo49xOcH/wb0rz/RGoe8W1AAAAAElFTkSuQmCC) repeat 0 0;
  background-size: 100%;
}

.highlight-time-page .bottom-line {
  width: 100%;
  position: fixed;
  bottom: 4 * 4.2px;
  left: 0;
  right: 0;
}

.highlight-time-page .box-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 14.53 * 4.2px;
  // background-size: 100% 100%;
  // background-image: url("../../../assets/images/app_ft_2.png");
}

img {
  border-style: none;
}

.box-main {
  position: relative;
  width: 100%;
  // padding-top: 6.67 * 4.2px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.box-main .box-header-bg {
  position: absolute;
  top: -1.33 * 4.2px;
  width: 100%;
  height: 38px;
  background: url("../../../assets/images/content-top.png");
  background-size: 100% 100%;
}

.box-main .box-list {
  height: -webkit-calc(100% - 8.8 * 4.2px);
  height: calc(100% - 8.8 * 4.2px);
  margin-top: 4.814px;
  // background: url("../../../assets/images/drop-info-all.png") repeat 0 0;
  // background-size: 100%;
  position: relative;
  padding-bottom: 5.33 * 4.2px;
}

.box-main .box-list .box-lucky {
  background: url("~@/assets/image3/high_time/3.png") no-repeat 0 0;
  background-size: 100% 100%;
}

.box-main .box-list .box-classic {
  background: url("~@/assets/image3/high_time/1.png") no-repeat 0 0;
  background-size: 100% 100%;
}

.box-main .box-list .box-fight {
  background: url("~@/assets/image3/high_time/2.png") no-repeat 0 0;
  background-size: 100% 100%;
}

.box-main .box-list .box-item {
  -webkit-transform: translate(0, -2 * 4.2px);
  -ms-transform: translate(0, -2 * 4.2px);
  transform: translate(0, -2 * 4.2px);
  margin: 0 auto 3.76 * 4.2px;
  width: 92 * 4.2px;
  height: 28.8 * 4.2px;
  background-size: 100% 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

// .box-main .box-list .box-item .box-left {
//   margin-left: 2.67 * 4.2px;
//   background: url("../../../assets/image3/high_time/listDarkBlue.png") no-repeat 0 0;
// }

.box-main .box-list .box-classic .box-left {
  width: 21.43 * 4.2px;
  height: 21.43 * 4.2px;
  margin: auto 2.67 * 4.2px;
  background: url("../../../assets/image3/high_time/shopDarkBlue.png") no-repeat 0 0;
  background-size: 100% 100%;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 21.43vw;
    height: 21.43vw;
    margin: auto 2.67vw;
  }
}

.box-main .box-list .box-fight .box-left {
  width: 21.43 * 4.2px;
  height: 21.43 * 4.2px;
  margin: auto 2.67 * 4.2px;
  background: url("../../../assets/image3/high_time/shopPurple.png") no-repeat 0 0;
  background-size: 100% 100%;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 21.43vw;
    height: 21.43vw;
    margin: auto 2.67vw;
  }
}

.box-main .box-list .box-lucky .box-left {
  width: 21.43 * 4.2px;
  height: 21.43 * 4.2px;
  margin: auto 2.67 * 4.2px;
  background: url("../../../assets/image3/high_time/shopBlue.png") no-repeat 0 0;
  background-size: 100% 100%;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 21.43vw;
    height: 21.43vw;
    margin: auto 2.67vw;
  }
}

.box-main .box-list .box-classic .box-left .box-name,
.box-main .box-list .box-fight .box-left .box-name,
.box-main .box-list .box-lucky .box-left .box-name {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 2.86 * 4.2px;
  color: #FFFFFF;
  position: absolute;
  top: 0;
  left: 5.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 2.86vw;
    left: 5.33vw;
  }
}

.box-main .box-list .box-item .box-left .box-type {
  width: 23.6 * 4.2px;
  margin-top: 1.6 * 4.2px;
  margin-left: 0.4 * 4.2px;
}

.box-main .box-list .box-item .box-left .box-gun {
  // margin-top: -1.33 * 4.2px;
  // margin-left: 4.8 * 4.2px;
  width: 18.27 * 4.2px;
  height: 10.67 * 4.2px;
  -o-object-fit: cover;
  object-fit: cover;
  position: relative;
  top: 7.14 * 4.2px;
  left: 0;
}

.box-main .box-list .box-item .box-right {
  margin-top: 4 * 4.2px;
  margin-right: 2 * 4.2px;
}

.box-main .box-list .box-item .box-right .box-time {
  margin-bottom: 2.27 * 4.2px;
  font-size: 2.67 * 4.2px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: right;
  color: #ffffff;
}

.box-main .box-list .box-item .box-right .box-msg {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 2.86 * 4.2px;
  color: #FFFFFF;
  display: flex;
  margin-right: 21.67 * 4.2px;
}

.box-main .box-list .box-item .box-right .box-msg .box-msg-value {
  display: flex;
  flex-direction: column;
  margin-left: -31.38 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-left: -31.38vw;
  }
}

.box-main .box-list .box-item .box-msg .dot-main {
  width: 1.67 * 4.2px;
  height: 1.67 * 4.2px;
  border-radius: 50px;
  margin-right: 1.19 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 1.67vw;
    height: 1.67vw;
    margin-right: 1.19vw;
  }
}

.box-main .box-list .box-right .box-msg .dot-main-classic {
  background: #20E9FF;
}

.box-main .box-list .box-fight .box-msg .dot-main-classic {
  background: #A620FF;
}

.box-main .box-list .box-lucky .box-msg .dot-main-classic {
  background: #20DAFF;
}

.box-main .box-list .box-item .box-right .box-msg .value-name {
  display: flex;
  text-align: left;
  margin-top: 3.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-top: 3.33vw;
  }
}

.box-main .box-list .box-item .box-right .box-msg .value-name img {
  width: 2.14 * 4.2px;
  height: 2.14 * 4.2px;
  margin: 0.95 * 4.2px 1.19 * 4.2px 0 0;

  @media only screen and (max-width: 430px) {
    width: 2.14vw;
    height: 2.14vw;
    margin: 0.95vw 1.19vw 0 0;
  }
}

.box-main .box-list .box-item .box-right .box-msg .box-msg-name {
  width: 16 * 4.2px;
  display: flex;
  flex-direction: column;
  margin-left: 4.76 * 4.2px;
  align-items: self-start;

  @media only screen and (max-width: 430px) {
    width: 16vw;
    margin-left: 4.76vw;
  }
}

.box-main .box-list .box-item .box-right .box-msg .value-name .name {
  width: 36 * 4.2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media only screen and (max-width: 430px) {
    width: 36vw;
  }
}

.box-main .box-list .box-item .box-right .box-msg .font-name {
  margin: 0.8 * 4.2px 1 * 4.2px 0;
}

.box-main .box-list .box-item .box-right .box-msg .font-name div {
  font-size: 3.33 * 4.2px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  color: #ffffff;
}

.box-main .box-list .box-item .box-right .box-msg .font-name .name-main {
  width: 18.93 * 4.2px;
  text-align: left;
  font-size: 12px;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.box-main .box-list .box-item .box-right .box-msg .font-name .name-main text {
  font-size: 2.93 * 4.2px;
  vertical-align: top;
}

.box-main .box-list .box-item .box-right .box-msg .font-title {
  margin: 0.67 * 4.2px 1 * 4.2px 0;
}

.box-main .box-list .box-item .box-right .box-msg .font-title div {
  font-size: 2.67 * 4.2px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  color: #b5b5b5;
}

.box-main .box-list .box-item .box-right .box-msg .font-title .name-main {
  width: 18.93 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.box-main .box-list .box-item .box-right .box-msg .font-title .name-main .fight-gun {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.box-main .box-list .box-item .box-right .box-msg .font-title .name-main .fight-gun img {
  width: 3.2 * 4.2px;
  height: 2.13 * 4.2px;
  margin-right: 0.67 * 4.2px;
}

.box-main .box-list .box-item .box-right .box-msg .font-title .name-main .fight-gun text {
  font-size: 2.67 * 4.2px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  color: #ffffff;
}

.box-main .box-list .box-item .box-right .box-msg .font-price {
  margin: 0.67 * 4.2px 1 * 4.2px 0;
}

.box-main .box-list .box-item .box-right .box-msg .font-price div {
  font-size: 2.8 * 4.2px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  font-weight: 500;
  color: #e4cbaf;
}

.box-main .box-list .box-item .box-right .box-msg .font-price .name-main {
  width: 18.93 * 4.2px;
  text-align: left;
}

.box-main .box-list .box-item .box-right .box-msg .flex-between {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.box-main .box-list .box-item .box-right .empty {
  margin-top: 4 * 4.2px;
  text-align: right;
}

.box-main .box-list .box-item .box-right .empty div {
  margin-top: 5.33 * 4.2px;
  margin-right: 13.33 * 4.2px;
}

.drop-info-all .drop-list {
  padding: 0 4 * 4.2px 8 * 4.2px;
  box-sizing: border-box;
  height: calc(100vh - 290px);
  overflow-y: scroll;
}

.drop-info-all .drop-list .drop-inner {
  height: 97.33 * 4.2px;
  overflow-y: scroll;
}

.drop-info-all .drop-list .drop-inner::-webkit-scrollbar {
  width: 0.67 * 4.2px;
  height: 0.67 * 4.2px;
}

.drop-info-all .drop-list .drop-inner::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
}

.drop-info-all .drop-list .drop-item {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 89.87 * 4.2px;
  height: 16 * 4.2px;
  font-size: 3.33 * 4.2px;
  margin: 0 0 2.4 * 4.2px 0;
  background-size: 100% 100%;
  background-image: url("../../../assets/image3/high_time/dljl-not-select.png");
  opacity: 0.9;
}

.drop-info-all .drop-list .drop-item.color-blue {
  // background-image: url("../../../assets/images/drop_blue.png");
}

.drop-info-all .drop-list .drop-item.color-purple {
  // background-image: url("../../../assets/images/drop_purple.png");
}

.drop-info-all .drop-list .drop-item.color-red {
  // background-image: url("../../../assets/images/drop_red.png");
}

.drop-info-all .drop-list .drop-item.color-golden {
  // background-image: url("../../../assets/images/drop_golden.png");
}

.drop-info-all .drop-list .drop-item .open-time {
  position: absolute;
  bottom: 0;
  right: 1.33 * 4.2px;
  width: 37.33 * 4.2px;
  height: 3.87 * 4.2px;
  line-height: 3.87 * 4.2px;
  margin: 0 0 0 5.2 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c0 {
  width: 23.07 * 4.2px;
  display: flex;
  align-items: center;
  margin-left: 4.76 * 4.5px;
}

.drop-info-all .drop-list .drop-item .item-c0 .head-box {
  position: relative;
  width: 10.67 * 4.2px;
  height: 10.67 * 4.2px;
  // margin: 1.07 * 4.2px 0 0 6.53 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c0 .head-box .head-img {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  top: 0;
  left: 0;
}

.drop-info-all .drop-list .drop-item .item-c0 .head-box .head-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-image: url("../../../assets/images/head_bk.png");
}

.drop-info-all .drop-list .drop-item .item-c0 .nick {
  // width: 18.67 * 4.2px;
  height: 5.2 * 4.2px;
  line-height: 5.2 * 4.2px;
  font-size: 3.33 * 4.2px;
  text-align: center;
  margin-left: 2.48 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c1 {
  width: 17.33 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c1 .c1-name {
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  width: 16.8 * 4.2px;
  color: #fff;
  margin: 2 * 4.2px 0 0 0;
}

.drop-info-all .drop-list .drop-item .item-c1 .c1-name .box-type {
  padding-right: 1.2 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c1 .c1-price {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  font-size: 3.47 * 4.2px;
  color: #ffe3c2;
  margin-top: 2 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c1 .c1-price .coin {
  float: left;
  width: 3.73 * 4.2px;
  height: 3.73 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c2 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: right;
  padding-left: 2.67 * 4.2px;
  margin: 2.5 * 4.2px 0 0 2 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c2 .c2-name {
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  width: 15.67 * 4.2px;
  color: #fff;
  margin-top: 2 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c2 .c2-price {
  width: 15.67 * 4.2px;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  font-size: 2.47 * 4.2px;
  color: #ffe3c2;
  margin-top: 1.33 * 4.2px;

}

.drop-info-all .drop-list .drop-item .item-c2 .c2-price .coin {
  width: 2.73 * 4.2px;
  height: 2.73 * 4.2px;
  margin-right: 1.19 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c2 .c2-price text {
  float: right;
}

.drop-info-all .drop-list .drop-item .item-c3 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 17.33 * 4.2px;
  margin-right: 1.33 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c3 .img {
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
  -o-object-fit: scale-down;
  object-fit: scale-down;
  margin-top: -1.6 * 4.2px;
}

@media only screen and (max-width: 430px) {
  .hight-time {
    --head-height: 14vw;
  }

  .highlight-time-page .highlight-time-title-img {
    width: 23.47vw;
    height: 5.87vw;
  }

  .highlight-time-page .new-s-custom-tabs-wrap {
    padding-top: 2vw;
  }

  .highlight-time-page .visitor-info {
    margin: -webkit-calc(7.33vw) 6.67vw 0 10.67vw;
    margin: calc(7.33vw) 6.67vw 0 10.67vw;

    height: 13.33vw;
  }

  .highlight-time-page .visitor-info .visitor-bg {
    width: 92.53vw;
    height: 20.13vw;
    position: absolute;
    top: -webkit-calc(var(--head-height) + 3.33vw);
    top: calc(var(--head-height) + 3.33vw);
    left: 3.67vw;
  }

  .highlight-time-page .visitor-info .user-info .avatar {
    width: 11.47vw;
    height: 11.47vw;
  }

  .highlight-time-page .visitor-info .user-info .avatar .header-bg {
    width: 25.33vw;
    height: 23.6vw;

    top: -6vw;
    left: -7.33vw;
  }

  .highlight-time-page .visitor-info .user-info .avatar .header-main {
    width: 11.9vw;
    height: 11.9vw;
    -webkit-border-radius: 50%;
    border-radius: 50%;
  }

  .highlight-time-page .visitor-info .user-info .nickname {
    width: 37.33vw;

    // top: -2.7vw;
    // left: 17.33vw;
    text-align: left;
  }

  .highlight-time-page .visitor-info .user-info .no-visitor {
    width: 22vw;
    margin-top: 4.67vw;
    margin-left: 12.67vw;
    font-size: 2.67vw;
  }

  .highlight-time-page .visitor-info .info-col text {
    font-size: 2.67vw;
  }

  .highlight-time-page .visitor-info .info-col .avatar-list {
    padding-top: 7.33vw;
    width: 33.07vw;
  }

  .highlight-time-page .visitor-info .info-col .avatar-list .avatar-img {
    margin-left: 1.07vw;
    width: 7.2vw;
    height: 7.2vw;
  }

  .highlight-time-page .visitor-info .info-col .avatar-list .avatar-img img {
    width: 7.2vw;
    height: 7.2vw;
  }

  .highlight-time-page .tab-bg {
    width: 100vw;
    height: 12.8vw;

    top: -webkit-calc(var(--head-height) + 21.33vw);
    top: calc(var(--head-height) + 21.33vw);
  }

  .highlight-time-page .tabs {
    margin: 5.67vw 3.8vw 3.67vw;
  }

  .highlight-time-page .tabs .tab {
    width: 22.33vw;

    font-size: 3.33vw;

    line-height: 8.67vw;
    // padding-top: 0.67vw;
  }

  .highlight-time-page .tabs .inactive-tab {
    background-size: 22.33vw 8.67vw;
  }

  .highlight-time-page .tabs .active-tab {
    background-size: 22.33vw 8.67vw;
  }

  .highlight-time-page .bg-content {
    -webkit-transform: translate(0, -2.8vw);
    -ms-transform: translate(0, -2.8vw);
    transform: translate(0, -2.8vw);
    height: 66.67vw;
  }

  .highlight-time-page .bottom-line {
    bottom: 4vw;
  }

  .highlight-time-page .box-footer {
    height: 14.53vw;
  }

  .box-main {
    // padding-top: 6.67vw;
  }

  .box-main .box-header-bg {
    position: absolute;
    top: -1.33vw;
    width: 100%;
    height: 38px;
    background: url("../../../assets/images/content-top.png");
    background-size: 100% 100%;
  }

  .box-main .box-list {
    height: -webkit-calc(100% - 8.8vw);
    height: calc(100% - 8.8vw);
    margin-top: 4.814px;
    // background: url("../../../assets/images/drop-info-all.png") repeat 0 0;
    // background-size: 100%;
    position: relative;
    padding-bottom: 5.33vw;
  }

  .box-main .box-list .box-item {
    -webkit-transform: translate(0, -2vw);
    -ms-transform: translate(0, -2vw);
    transform: translate(0, -2vw);
    margin: 0 auto 3.76vw;
    width: 92vw;
    height: 28.8vw;
  }

  .box-main .box-list .box-item .box-left {
    margin-left: 2.67vw;
  }

  .box-main .box-list .box-item .box-left .box-type {
    width: 23.6vw;
    margin-top: 1.6vw;
    margin-left: 0.4vw;
  }

  .box-main .box-list .box-item .box-left .box-gun {
    // margin-top: -1.33vw;
    // margin-left: 4.8vw;
    width: 18.27vw;
    height: 10.67vw;
    top: 7.14vw;
    left: 0;
  }

  .box-main .box-list .box-item .box-right {
    margin-top: 4vw;
    margin-right: 2vw;
  }

  .box-main .box-list .box-item .box-right .box-time {
    margin-bottom: 2.27vw;
    font-size: 2.67vw;
  }

  .box-main .box-list .box-item .box-right .box-msg {
    font-size: 2.86vw;
    margin-right: 21.67vw;
  }

  .box-main .box-list .box-item .box-right .box-msg .font-name {
    margin: 0.8vw 1vw 0;
  }

  .box-main .box-list .box-item .box-right .box-msg .font-name div {
    font-size: 3.33vw;
  }

  .box-main .box-list .box-item .box-right .box-msg .font-name .name-main {
    width: 18.93vw;
  }

  .box-main .box-list .box-item .box-right .box-msg .font-name .name-main text {
    font-size: 2.93vw;
  }

  .box-main .box-list .box-item .box-right .box-msg .font-title {
    margin: 0.67vw 1vw 0;
  }

  .box-main .box-list .box-item .box-right .box-msg .font-title div {
    font-size: 2.67vw;
  }

  .box-main .box-list .box-item .box-right .box-msg .font-title .name-main {
    width: 18.93vw;
  }

  .box-main .box-list .box-item .box-right .box-msg .font-title .name-main .fight-gun img {
    width: 3.2vw;
    height: 2.13vw;
    margin-right: 0.67vw;
  }

  .box-main .box-list .box-item .box-right .box-msg .font-title .name-main .fight-gun text {
    font-size: 2.67vw;
  }

  .box-main .box-list .box-item .box-right .box-msg .font-price {
    margin: 0.67vw 1vw 0;
  }

  .box-main .box-list .box-item .box-right .box-msg .font-price div {
    font-size: 2.8vw;
  }

  .box-main .box-list .box-item .box-right .box-msg .font-price .name-main {
    width: 18.93vw;
  }

  .box-main .box-list .box-item .box-right .empty {
    margin-top: 4vw;
  }

  .box-main .box-list .box-item .box-right .empty div {
    margin-top: 5.33vw;
    margin-right: 13.33vw;
  }

  .drop-info-all .drop-list {
    padding: 0 4vw 8vw;

    height: 67vh;
  }

  .drop-info-all .drop-list .drop-inner {
    height: 97.33vw;
  }

  .drop-info-all .drop-list .drop-inner::-webkit-scrollbar {
    width: 0.67vw;
    height: 0.67vw;
  }

  .drop-info-all .drop-list .drop-item {
    width: 89.87vw;
    height: 16vw;
    font-size: 3.33vw;
    margin: 0 0 2.4vw 0;
  }

  .drop-info-all .drop-list .drop-item .open-time {
    position: absolute;
    bottom: 0;
    right: 1.33vw;
    width: 37.33vw;
    height: 3.87vw;
    line-height: 3.87vw;
    margin: 0 0 0 5.2vw;
  }

  .drop-info-all .drop-list .drop-item .item-c0 {
    width: 23.07vw;
    margin-left: 4.76vw;
  }

  .drop-info-all .drop-list .drop-item .item-c0 .head-box {
    width: 10.67vw;
    height: 10.67vw;
    // margin: 1.07vw 0 0 6.53vw;
  }

  .drop-info-all .drop-list .drop-item .item-c0 .nick {
    // width: 18.67vw;
    height: 5.2vw;
    line-height: 5.2vw;
    font-size: 3.33vw;
    text-align: center;
    margin-left: 2.48vw;
  }

  .drop-info-all .drop-list .drop-item .item-c1 {
    width: 17.33vw;
  }

  .drop-info-all .drop-list .drop-item .item-c1 .c1-name {
    height: 4vw;
    line-height: 4vw;
    width: 16.8vw;
    color: #fff;
    margin: 2vw 0 0 0;
  }

  .drop-info-all .drop-list .drop-item .item-c1 .c1-name .box-type {
    padding-right: 1.2vw;
  }

  .drop-info-all .drop-list .drop-item .item-c1 .c1-price {
    height: 4vw;
    line-height: 4vw;
    font-size: 3.47vw;
    color: #ffe3c2;
    margin-top: 2vw;
  }

  .drop-info-all .drop-list .drop-item .item-c1 .c1-price .coin {
    width: 3.73vw;
    height: 3.73vw;
  }

  .drop-info-all .drop-list .drop-item .item-c2 {
    padding-left: 2.67vw;
    margin: 2.5vw 0 0 2vw;
  }

  .drop-info-all .drop-list .drop-item .item-c2 .c2-name {
    height: 4vw;
    line-height: 4vw;
    width: 15.67vw;
    color: #fff;
    margin-top: 2vw;
  }

  .drop-info-all .drop-list .drop-item .item-c2 .c2-price {
    width: 15.67vw;
    height: 4vw;
    line-height: 4vw;
    font-size: 2.47vw;
    color: #ffe3c2;
    margin-top: 1.33vw;
  }

  .drop-info-all .drop-list .drop-item .item-c2 .c2-price .coin {
    width: 2.73vw;
    height: 2.73vw;
    margin-right: 1.19vw;
  }

  .drop-info-all .drop-list .drop-item .item-c3 {
    width: 17.33vw;
    margin-right: 1.33vw;
  }

  .drop-info-all .drop-list .drop-item .item-c3 .img {
    width: 13.33vw;
    height: 13.33vw;
    margin-top: -1.6vw;
  }
}
</style>